import React, { Component } from 'react'

import './style.scss'

class About extends Component {
  render () {
    return (
      <div className="about">
        <div className="image">
        </div>
        <div className="bio">
          Software developer  &amp; Certified Scrum Master, Game development enthusiast, 
          Pixelart hobbyist who enjoys cooking and ride motorcycles.
          <div className="emoji">
            🤖 &nbsp;👾&nbsp;🍳&nbsp;🇲🇽&nbsp;🏍
          </div>
        </div>
      </div>
    )
  }
}

export default About


// WEBPACK FOOTER //
// ./src/components/Sidebar/About/index.js